import { render } from "./MuchSection.vue?vue&type=template&id=e0259958&scoped=true"
import script from "./MuchSection.vue?vue&type=script&lang=js"
export * from "./MuchSection.vue?vue&type=script&lang=js"

import "./MuchSection.vue?vue&type=style&index=0&id=e0259958&scoped=true&lang=css"

import exportComponent from "/Users/bellakwon/Desktop/thesis01/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0259958"]])

export default __exports__